import { showAction as lockUi, hideAction as unlockUi } from '../../_flux/actions/ui_lock_actions';
import getTranslatedText from '../../_flux/helper/get_translated_text';
import { setPreselectFS } from '../../_flux/helper/requests/preselect_fs';
import { approved, denied } from '../../_modules/google_analytics/geolocation';
import { getValue } from '../local_storage';

const setGeoLocation = (type) => {
    let hasOutletId = window.location.href.indexOf('outlet_id') !== -1;
    let hasZipcode = window.location.href.indexOf('zipcode') !== -1;

    if (hasOutletId || hasZipcode) {
        const urlParams = new URLSearchParams(window.location.search);
        const params = {
            spinachIdF: urlParams.get('outlet_id'),
            postcode: urlParams.get('zipcode'),
        };

        setPreselectFS(params, urlParams, type);
    } else {
        const shippingPostcode = getValue('shippingPostcode');
        if (!shippingPostcode) {
            navigator.geolocation.getCurrentPosition(onSuccess.bind(this, type), onError.bind(this, type));
        }
    }
};


const onSuccess = (type, position) => {
    approved();
    if (type === 'pdp') {
        window.uiLockText = getTranslatedText('pdp-ui-lock-text');
    } else if (type === 'catalog') {
        window.uiLockText = getTranslatedText('catalog-ui-lock-text');
    }
    lockUi();
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    const customerLocation = {
        latitude: latitude,
        longitude: longitude,
    };

    setPreselectFS(customerLocation, null, type);
};
const onError = (type, e) => {
    denied();
    console.log('GeoLocation Denied: ', e);
    setPreselectFS(null, null, type);
};


export default setGeoLocation;
